<template>
  <v-container fluid>
    <v-skeleton-loader
      :loading="!flagNav"
      transition="scale-transition"
      max-height="64"
      type="table-heading">
      <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Token summation</v-toolbar-title>
        <v-spacer />
        <div class="d-flex pr-4">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
        </div>
      </v-toolbar>
    </v-skeleton-loader>
    <v-card class="reportdata-card-main" style="margin-top: 1rem">
      <v-card-title class="d-flex align-center justify-space-between mb-4">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-3" size="28">mdi-calculator</v-icon>
          <h3 class="text-h5 font-weight-bold text-primary">
            Token Summation Report Management
          </h3>
        </div>
      </v-card-title>

      <v-card-text style="padding: 0">
        <!-- Main Filter Row -->
        <v-row class="mb-4">
          <!-- Model Filters Section -->
          <v-col cols="6" md="8">
            <div class="reportdata-filter-section">
              <h4 class="reportdata-section-title mb-3">
                <v-icon class="mr-2 ml-2" color="primary" size="20">mdi-tune</v-icon>
                Model Filters
              </h4>
              <v-row class="mx-3">
                <v-col cols="6">
                  <v-card variant="outlined" class="reportdata-card-outlined">
                    <v-card-text class="pa-3">
                      <v-text-field
                        id="id-field-search-reporttokensum"
                        label="Model ID"
                        placeholder="Enter Model ID"
                        v-model="modelIDForQuery"
                        @keypress="isNumberpositive($event)"
                        variant="outlined"
                        density="compact"
                        color="primary"
                        prepend-inner-icon="mdi-identifier"
                        clearable>
                        <template #append-inner>
                          <v-tooltip location="top" max-width="200">
                            <template #activator="{ props }">
                              <v-icon
                                size="small"
                                color="grey-darken-1"
                                v-bind="props">
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>Enter model ID to filter results</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card variant="outlined" class="reportdata-card-outlined">
                    <v-card-text class="pa-3">
                      <v-text-field
                        id="modelname-field-search-reporttokensum"
                        label="Model Name"
                        placeholder="Enter Model Name"
                        v-model="modelNameForQuery"
                        type="text"
                        variant="outlined"
                        density="compact"
                        color="primary"
                        prepend-inner-icon="mdi-text"
                        clearable>
                        <template #append-inner>
                          <v-tooltip location="top" max-width="200">
                            <template #activator="{ props }">
                              <v-icon
                                size="small"
                                color="grey-darken-1"
                                v-bind="props">
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>Enter model name to filter results</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <!-- Statistics Section -->
          <v-col cols="6" md="4">
            <div class="reportdata-filter-section">
              <h4 class="reportdata-section-title mb-3">
                <v-icon class="mr-2" color="primary" size="20">
                  mdi-chart-box
                </v-icon>
                Statistics
              </h4>
              <v-card
                variant="outlined"
                class="reportdata-card-outlined reportdata-card-stats mx-4">
                <v-card-text class="pa-3">
                  <div class="text-center">
                    <v-chip
                      size="large"
                      color="info"
                      variant="elevated"
                      class="px-4">
                      <v-icon class="mr-2">mdi-database</v-icon>
                      {{ listTotaltoken.allRow }} Models
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <!-- Date Range Section -->
          <v-col cols="12" md="12">
            <div class="reportdata-filter-section">
              <h4 class="reportdata-section-title mb-3">
                <v-icon class="mr-2 ml-2" color="primary" size="20">
                  mdi-calendar-range
                </v-icon>
                Date Range
              </h4>
              <v-row class="mx-3">
                <v-col cols="5">
                  <v-card variant="outlined" class="reportdata-card-outlined">
                    <v-card-text class="pa-3">
                      <v-menu
                        v-model="startDateFlag"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom"
                        min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            id="startdate-field-reporttokensum"
                            v-model="startDate"
                            label="Start Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="reportdata-field-date"
                            :rules="[rules.required]"
                            clearable>
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon
                                    size="small"
                                    color="grey-darken-1"
                                    v-bind="props">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>Select start date for report</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          id="startdate-datapicker-reporttokensum"
                          v-model="startDate"
                          :max="endDate != null ? endDate : null"
                          @update:model-value="
                            (val) => {
                              startDate = formatDate(val);
                              startDateFlag = false;
                            }
                          "
                          color="primary"></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="2" class="d-flex align-center justify-center">
                  <v-icon color="grey-darken-2" size="24">
                    mdi-arrow-right
                  </v-icon>
                </v-col>

                <v-col cols="5">
                  <v-card variant="outlined" class="reportdata-card-outlined">
                    <v-card-text class="pa-3">
                      <v-menu
                        v-model="endDateFlag"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom"
                        min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            id="enddate-field-reporttokensum"
                            v-model="endDate"
                            label="End Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="reportdata-field-date"
                            :rules="[rules.required]"
                            clearable>
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon
                                    size="small"
                                    color="grey-darken-1"
                                    v-bind="props">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>Select end date for report</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          id="enddate-datapicker-reporttokensum"
                          v-model="endDate"
                          :min="startDate != null ? startDate : null"
                          @update:model-value="
                            (val) => {
                              endDate = formatDate(val);
                              endDateFlag = false;
                            }
                          "
                          color="primary"></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <!-- Action Buttons Row -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card variant="outlined" class="reportdata-card-action">
              <v-card-text class="pa-4">
                <div
                  class="d-flex justify-space-between align-center flex-wrap ga-3 reportdata-flex-responsive">
                  <!-- Left Side - Search Button -->
                  <div class="reportdata-action-group">
                    <v-btn
                      color="primary"
                      variant="elevated"
                      size="large"
                      @click="Search"
                      class="reportdata-btn-search"
                      prepend-icon="mdi-magnify">
                      Search
                    </v-btn>
                  </div>

                  <!-- Right Side - Download Button -->
                  <div class="reportdata-action-group">
                    <v-btn
                      color="success"
                      variant="elevated"
                      size="large"
                      @click="GetForDownload()"
                      class="reportdata-btn-download"
                      prepend-icon="mdi-download">
                      Download Report
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Data Table with Modern Styling -->
        <v-card class="reportdata-card-table">
          <div class="reportdata-table-container">
            <v-data-table-server
              v-model:options="options"
              :items="listTotaltoken.modelDetail"
              :items-per-page="options.itemsPerPage"
              :headers="headers"
              :items-length="listTotaltoken.allRow"
              :loading="loadingTable"
              :footer-props="{
                'items-per-page-options': [5, 10, 25, 50, 100],
              }"
              class="reportdata-token-table-modern"
              density="comfortable"
              hover>
              <template #top>
                <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                  <v-toolbar-title class="text-h6 font-weight-medium">
                    <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                    Token Summation Data ({{ listTotaltoken.allRow }} records)
                  </v-toolbar-title>
                </v-toolbar>
              </template>

              <template #item="{ item }">
                <tr class="reportdata-table-row">
                  <td class="text-center">
                    {{ item.number }}
                  </td>
                  <td class="text-center">
                    {{ item.modelDisplay }}
                  </td>
                  <td>
                    <div class="text-container">
                      <span class="reportdata-text-standard">
                        {{ item.modelName }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="text-container">
                      <span class="reportdata-text-standard">
                        {{ item.model }}
                      </span>
                    </div>
                  </td>
                  <td class="text-center">
                    {{ item.llmName }}
                  </td>
                  <td class="text-center">
                    {{ item.totalPromptTokenDisplay }}
                  </td>
                  <td class="text-center">
                    {{ item.totalCompletionTokensDisplay }}
                  </td>
                  <td class="text-center">
                    {{ item.totalTokenDisplay }}
                  </td>
                  <td class="text-center">
                    {{ item.totalImageGeneration }}
                  </td>
                  <td class="text-center">
                    {{ item.totalCachedTokens }}
                  </td>
                  <td class="text-center">
                    {{ item.totalReasoningTokens }}
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
export default {
  name: "ReportTokenSum",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    loadingTable:false,
    isIntialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    totalRow: 0,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    modelIDForQuery: "",
    loading: false,
    modelNameForQuery: "",
    sortBy: [],
    sortDesc: [],
    isSearch: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    listTotaltoken: {
      number: 0,
      allRow: 0,
      modelDetail: [
        {
          number: "number",
          modelName: "",
          model: "",
          modelDisplay: 0,
          totalToken: 0,
        },
      ],
    },
    headers: [
      {
        title: "No.",
        align: "center",
        value: "number",
        sortable: false,
        width: "60px",
        minWidth: "60px",
      },
      {
        title: "Model ID",
        align: "center",
        value: "modelDisplay",
        sortable: true,
        width: "80px",
        minWidth: "80px",
      },
      {
        title: "Model Name",
        align: "left",
        value: "modelName",
        sortable: true,
        width: "200px",
        minWidth: "180px",
      },
      {
        title: "Model",
        align: "left",
        value: "model",
        sortable: true,
        width: "160px",
        minWidth: "140px",
      },
      {
        title: "LLM",
        align: "left",
        value: "model",
        sortable: true,
        width: "160px",
        minWidth: "140px",
      },
      {
        title: "Input Tokens",
        align: "center",
        value: "totalPromptTokenDisplay",
        sortable: true,
        width: "120px",
        minWidth: "100px",
      },
      {
        title: "Output Tokens",
        align: "center",
        value: "totalCompletionTokensDisplay",
        sortable: true,
        width: "120px",
        minWidth: "100px",
      },
      {
        title: "Total Tokens",
        align: "center",
        value: "totalTokenDisplay",
        sortable: true,
        width: "120px",
        minWidth: "100px",
      },
      {
        title: "Image Gen.",
        align: "center",
        value: "totalImageGeneration",
        sortable: true,
        width: "100px",
        minWidth: "90px",
      },
      {
        title: "Cached",
        align: "center",
        value: "totalCachedTokens",
        sortable: true,
        width: "100px",
        minWidth: "90px",
      },
      {
        title: "Reasoning",
        align: "center",
        value: "totalReasoningTokens",
        sortable: true,
        width: "100px",
        minWidth: "90px",
      },
    ],
  }),
  watch: {
    options: {
      handler() {
        if (!this.isIntialized) return;
        this.fetchReport();
      },
      deep: true,
    },
  },
  mounted() {
    let self = this;
    var date = new Date();
    self.startDate = self.convertDateToString2(date);
    self.endDate = self.convertDateToString2(date);
    self.GetDate();
    self.Search();
    this.isIntialized = true;
      },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    formatNumber(value) {
      return value.toLocaleString();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.fetchReport();
    },
    fetchReport() {
      let self = this;
      if (self.isSearch) {
        self.options.page = 1;
        self.options.itemsPerPage = 10;
      }
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      self.loadingTable = true;
      var tempData = {
        startDate: self.startDate,
        stopDate: self.endDate,
        page: page,
        pageResult: itemsPerPage,
        modelIDForQuery: self.modelIDForQuery,
        modelNameForQuery: self.modelNameForQuery,
        sortBy: sortField,
        sortDesc: sortOrder,
      };
      if (tempData.modelIDForQuery == "" || tempData.modelIDForQuery == null) {
        tempData.modelIDForQuery = -1;
      }

      self.$call.ReportTokenSum(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listTotaltoken.modelDetail = dataResponse.data.listData;
            if (self.listTotaltoken.modelDetail.length != 0) {
              self.listTotaltoken.allRow = dataResponse.data.allRow;

              self.listTotaltoken.modelDetail.forEach((l) => {
                l.totalPromptTokenDisplay = l.totalPromptToken.toLocaleString();
                l.totalCompletionTokensDisplay =
                  l.totalCompletionTokens.toLocaleString();
                l.totalTokenDisplay = l.totalToken.toLocaleString();
                l.totalImageGeneration =
                  l.totalImageGeneration.toLocaleString();
                l.totalCachedTokens = l.totalCachedTokens.toLocaleString();
                l.totalReasoningTokens =
                  l.totalReasoningTokens.toLocaleString();
              });
            }

            self.loadingTable = false;
            self.isSearch = false;
          }
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    async GetForDownload() {
      let self = this;
      self.loading = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      var tempData = {
        startDate: self.startDate,
        stopDate: self.endDate,
        page: page,
        pageResult: itemsPerPage,
        modelIDForQuery: self.modelIDForQuery,
        modelNameForQuery: self.modelNameForQuery,
        sortBy: sortField,
        sortDesc: sortOrder,
      };
      if (tempData.modelIDForQuery == "") {
        tempData.modelIDForQuery = -1;
      }

      await self.$call.ExportReportTokenSummation(
        tempData,
        async (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            // fileLink.setAttribute('href', fileURL);

            let fileNameShow = `ReportTokenSummation__${self.convertDateToString(
              new Date(),
              ""
            )}.xlsx`;
            fileLink.setAttribute("download", fileNameShow);
            document.body.appendChild(fileLink);

            fileLink.click();
            document.body.removeChild(fileLink);
          }
          self.loading = false;
        },
        async (errorResource) => {
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
  },
};
</script>
<style scoped></style>
